import { useState } from "react";
import { PairCard, PairViewer } from "../jobs/PairCard";

export function ClientBeforeAfter({ pairs = [] }) {
  const [viewing, setViewing] = useState(null);
  if (!pairs.length) return null;
  return (
    <div className="grid gap-3 md:grid-cols-2" data-testid="client-before-after">
      {pairs.map((p) => <PairCard key={p.id} pair={p} onOpen={() => setViewing(p)} testid={`client-pair-${p.id}`} />)}
      {viewing && <PairViewer pair={viewing} onClose={() => setViewing(null)} />}
    </div>
  );
}
